import React from "react";
import { useInView } from "react-intersection-observer";

const SectionContainer = ({ title, data, gridClasses }) => {
  return (
    <section
      className="py-20 px-4 md:px-10 lg:px-16"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <h2 className="text-3xl font-bold text-center mb-8">{title}</h2>
      <div className={gridClasses}>
        {data.map((item, index) => {
          const [ref, inView] = useInView({
            triggerOnce: true,
            threshold: 0.2,
          });

          return (
            <div
              ref={ref}
              key={index}
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(50px)",
                transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
                border: "1px solid #D3D3D3",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "3rem",
              }}
              className="card bg-white rounded-lg text-center flex flex-col justify-start items-center"
            >
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p>{item.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SectionContainer;
